<app-page-heading
    [key]="(mode === DisplayMode.Creation ? 'regions.form.page-title.creation' : 'regions.form.page-title.edition')"
    [subheadingIcon]="'fa fa-truck'"></app-page-heading>

<div class="menuTabList">
    <div class="col-xs-8">
        <button type="button" class="btn btn-primary btn-outline btn-lg pull-left" (click)="location.back()">
            <span class="fa fa-arrow-left"> </span>
        </button>
    </div>
</div>

<app-tabs *ngIf="region" class="overlay-content">
    <app-tab *ngIf="!onConfig" [tabId]="'info'"
             [selected]="activeTab === 'info'"
             [tabTextKey]="'regions.form.section.general'"
             (selectedChange)="activeTab = 'info'">
        <ng-container>
            <div class="regionDetail-config-container">
                <form #generalForm="ngForm" (submit)="processForm()" novalidate class="row">
                    <fieldset [disabled]="formProcessingBlocked" class="col-xs-12">
                        <h2 class="text-uppercase" [i18n]="'regions.form.sub-sections.information'"></h2>
                        <div class="form-group">
                            <div class="requiredInput">
                                <label class="control-label" for="region-name"
                                       [i18n]="'regions.form.name.label'"></label>
                                <i class="fa fa-asterisk m-r-xxs requiredInput-icon"></i>
                            </div>
                            <input class="form-control" name="region-name" id="region-name" type="text"
                                   [(ngModel)]="region.name" required>
                        </div>

                        <div class="form-group">
                            <div class="requiredInput">
                                <label class="control-label"
                                       [i18n]="'regions.form.preferred-language.label'"></label>
                                <i class="fa fa-asterisk m-r-xxs requiredInput-icon"></i>
                            </div>
                            <ng-select
                                [required]="true"
                                [name]="'region-preferred-language'"
                                [addTag]="false"
                                [hideSelected]="false"
                                [(ngModel)]="region.preferredLanguage">
                                <ng-option *ngFor="let language of languages"
                                           [value]="language.cmblLangCode"
                                           [i18n]="'languages.'+language.labelKey">
                                </ng-option>
                            </ng-select>
                            <span class="flex-row bottom-align">
                                <i class="fa fa-info-circle space-right-5"></i>
                                <small class="help-block m-b-none" [i18n]="'regions.form.preferred-language.help'"></small>
                            </span>
                        </div>

                        <div class="form-group">
                            <div class="requiredInput">
                                <label class="control-label" [i18n]="'regions.form.preferred-timezone.label'"></label>
                                <i class="fa fa-asterisk m-r-xxs requiredInput-icon"></i>
                            </div>
                            <ng-select
                                [required]="true"
                                [items]="timezones"
                                [name]="'region-preferred-timezone'"
                                [addTag]="false"
                                [hideSelected]="false"
                                [(ngModel)]="region.preferredTimezone">
                            </ng-select>
                        </div>

                        <div class="form-group">
                            <label class="control-label" for="region-distance-unit"
                                   [i18n]="'regions.form.distance-unit.label'"></label>
                            <select [(ngModel)]="region.distanceUnit" id="region-distance-unit"
                                    name="region-distance-unit" class="form-control">
                                <option [ngValue]="DistanceUnit.KILOMETERS"
                                        [i18n]="'distance-unit.kilometers'"></option>
                                <option [ngValue]="DistanceUnit.MILES" [i18n]="'distance-unit.miles'"></option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label class="control-label" [i18n]="'regions.form.countries.label'"></label>
                            <ng-select
                                bindLabel="displayLabel"
                                [items]="countries"
                                [name]="'region-countries'"
                                [(ngModel)]="region.countries"
                                [multiple]="true">
                            </ng-select>
                            <span class="flex-row bottom-align">
                                <i class="fa fa-info-circle space-right-5"></i>
                                <small class="help-block m-b-none" [i18n]="'regions.form.countries.help'"></small>
                            </span>
                        </div>

                        <div class="form-group">
                            <label class="control-label" for="region-overdue-max-days-update"
                                   [i18n]="'regions.form.overdue-max-days-update.label'"></label>
                            <input type="number"
                                   class="form-control"
                                   id="region-overdue-max-days-update"
                                   name="region-overdue-max-days-update"
                                   [(ngModel)]="region.features.overdueMaxDaysUpdate"
                                   [min]="1"
                                   (keydown)="onNumberInputKeydown($event)"
                                   required>
                            <span class="flex-row bottom-align">
                                <i class="fa fa-info-circle space-right-5"></i>
                                <small class="help-block m-b-none"
                                      [i18n]="'regions.form.overdue-max-days-update.help'"></small>
                            </span>
                        </div>

                        <h2 class="text-uppercase" [i18n]="'regions.form.sub-sections.notification'"></h2>

                        <div class="form-group">
                            <label class="control-label"
                                   [i18n]="'regions.form.failed-pickup-email.title'"></label>
                            <ng-select
                                bindLabel="failedPickupEmails"
                                [name]="'failed-pickup-email'"
                                [(ngModel)]="region.failedPickupContactEmails"
                                [multiple]="true">
                            </ng-select>
                            <span class="flex-row bottom-align">
                                <i class="fa fa-info-circle space-right-5"></i>
                                <small class="help-block m-b-none"
                                       [i18n]="'regions.form.failed-pickup-email.sub-title'"></small>
                            </span>
                        </div>
                        <app-data-filter-fieldSet class="form-group" [fieldsetTitleKey]="'regions.form.hotspots-alerts-email.title'">
                            <app-data-filter-form-autocomplete
                                [name]="'hotspotAlertEmails'"
                                [notFoundTextKey]="'regions.form.hotspots-alerts-email.notfound' | translate"
                                [(model)]="region.hotspotAlertsContactEmails"
                                [multiple]="true">
                            </app-data-filter-form-autocomplete>
                            <span class="flex-row bottom-align">
                                <i class="fa fa-info-circle space-right-5"></i>
                                <small class="help-block m-b-none" [i18n]="'regions.form.hotspots-alerts-email.help'"></small>
                            </span>

                            <div class="space-top-10 hotspot-sub-title" [i18n]="'regions.form.hotspots-alerts-email.sub-title'"></div>
                            <div class="flex-row center-align">
                                <input type='number' class="form-control" id="minutesSpentInHotspotArea" min="0"
                                       name="minutesSpentInHotspotArea" value="0"
                                       [(ngModel)]="region.minutesSpentInHotspotArea">
                            </div>
                            <span class="flex-row bottom-align">
                                <i class="fa fa-info-circle space-right-5"></i>
                                <small class="help-block m-b-none"
                                   [i18n]="'regions.form.hotspots-alerts-email.time-spent'"></small>
                            </span>
                        </app-data-filter-fieldSet>
                        <div class="form-group">
                            <label class="control-label" [i18n]="'regions.form.re-route-email.title'"></label>
                            <ng-select
                                bindLabel="name"
                                [name]="'re-route-email'"
                                [(ngModel)]="region.reRouteErrorContactEmails"
                                [multiple]="true">
                            </ng-select>
                            <span class="flex-row bottom-align">
                                <i class="fa fa-info-circle space-right-5"></i>
                                <small class="help-block m-b-none"
                                   [i18n]="'regions.form.re-route-email.sub-title'"></small>
                            </span>
                        </div>

                        <app-region-feature-new [displayMode]="RegionFeatureDisplayMode.ON_OFF_FEATURE_MODE"
                                                [groupName]="'customizeBluechat'"
                                                [translationNode]="'regions.form.customize-bluechat'"
                                                [value]="region.features.customizeBluechatFooterValue"
                                                (valueChange)="customizeBluechatActivationChanged($event)"
                                                [regionId]="region.id"
                                                [hideSeparator]="true">
                                            <ng-select
                                                [disabled]="region.features.customizeBluechatFooterValue === OnOffFeature.OFF"
                                                bindLabel="name"
                                                [name]="'bluechat-note-footer-fields'"
                                                [(ngModel)]="region.features.bluechatNoteFooterFields"
                                                [multiple]="true">
                                                <ng-option *ngFor="let bluechatNoteFooterField of bluechatNoteFooterFields"
                                                           [value]="bluechatNoteFooterField"
                                                           [i18n]="'regions.form.bluechat-note-footer-fields.'+ bluechatNoteFooterField">
                                                </ng-option>
                                            </ng-select>
                        </app-region-feature-new>
                    </fieldset>
                </form>
            </div>
        </ng-container>
    </app-tab>
    <app-tab *ngIf="!onConfig" [tabId]="'locations'"
             [selected]="activeTab === 'locations'"
             [tabTextKey]="'regions.form.section.locations'"
             (selectedChange)="activeTab = 'locations'">
        <ng-container>
            <div class="regionDetail-config-container">
                <form #locationsForm="ngForm" (submit)="processForm()" novalidate class="row">
                    <fieldset [disabled]="formProcessingBlocked" class="col-xs-12">
                        <h2 class="text-uppercase" [i18n]="'regions.form.sub-sections.pod'"></h2>
                        <app-data-filter-fieldSet
                            [fieldsetTitleKey]="'regions.form.sap-document-type-upload-to-by.title'">
                            <div class="space-top-10">
                                <app-region-feature-new [displayMode]="RegionFeatureDisplayMode.MULTI_SELECTION_MODE"
                                                        [groupName]="'sapDocumentTypeUploadToBlueyonder'"
                                                        [translationNode]="'regions.form.sap-document-type-upload-to-by'"
                                                        [(value)]="region.features.sapDocumentTypeUploadToBlueyonder"
                                                        [possibleValues]="sapDocumentTypeUploadToBlueyonder"
                                                        [regionFeature]="RegionFeature.SAP_DOCUMENT_TYPE_UPLOAD_TO_BLUEYONDER"
                                                        [regionId]="region.id"
                                                        [hideSeparator]="true"
                                                        [displayMoreDescription]="true"></app-region-feature-new>
                            </div>
                        </app-data-filter-fieldSet>

                        <h2 class="text-uppercase" [i18n]="'regions.form.sub-sections.cico'"></h2>

                        <app-region-feature-status
                            [(ngModel)]="region.features.z1CheckoutToMyChep"
                            [name]="'z1-checkout-to-my-chep'"
                            [i18nKeyNode]="'regions.form.z1-checkout-to-my-chep'"></app-region-feature-status>

                        <app-region-feature-status
                            [(ngModel)]="region.features.askZ2EtaCico"
                            [name]="'ask-z2-eta-cico1'"
                            [i18nKeyNode]="'regions.form.ask-cico-eta'"></app-region-feature-status>

                        <app-region-feature-status
                            [(ngModel)]="region.features.cmaCicoAlignment"
                            [name]="'cma-cico-alignment1'"
                            [i18nKeyNode]="'regions.form.cma-cico-alignment'"></app-region-feature-status>

                        <app-region-feature-status
                            [(ngModel)]="region.features.documentDownloadQrCodeAvailability"
                            [name]="'document-download-qr-code-availability'"
                            [i18nKeyNode]="'regions.form.document-download-qr-code-availability'"></app-region-feature-status>

                        <h2 class="text-uppercase" [i18n]="'regions.form.sub-sections.cma'"></h2>

                        <app-data-filter-fieldSet [fieldsetTitleKey]="'regions.form.reverse-cma-check-in.title'">
                                <div class="flex-row center-align">
                                    <div class="flex-column grow space-right-30">
                                        <span class="dspl-block inner-space-top-8">
                                            <i class="fa fa-info-circle space-right-5"></i>
                                            <span [i18n]="'regions.form.reverse-cma-check-in.sub-title'"></span>
                                        </span>
                                    </div>
                                    <div class="flex-row no-shrink">
                                        <app-switcher
                                            class="space-right-25"
                                            id="reverse-check-in-no-colt"
                                            [labelKey]="'regions.form.reverse-cma-check-in.non-yms.title'"
                                            [(ngModel)]="region.features.reverseCheckinNonYMS"
                                            [name]="'reverse-check-in-contact-emails'">
                                        </app-switcher>
                                        <app-switcher
                                            id="reverse-check-in-customer"
                                            [labelKey]="'regions.form.reverse-cma-check-in.customer.title'"
                                            [(ngModel)]="region.features.reverseCheckinCustomer"
                                            [name]="'reverse-check-in-reasons'">
                                        </app-switcher>
                                    </div>
                                </div>
                            <div *ngIf="region.features.reverseCheckinNonYMS || region.features.reverseCheckinCustomer">
                                <div class="form-group">
                                    <div class="requiredInput">
                                        <label class="control-label" [i18n]="'regions.form.reverse-cma-check-in.notification.title'"></label>
                                        <i class="fa fa-asterisk m-r-xxs requiredInput-icon"></i>
                                    </div>
                                    <app-data-filter-form-autocomplete
                                        [name]="'reverseCheckinContactEmails'"
                                        [notFoundTextKey]="'common.not-found-item' | translate"
                                        [(model)]="region.features.reverseCheckinContactEmails"
                                        [multiple]="true"
                                        required>
                                    </app-data-filter-form-autocomplete>
                                    <span class="flex-row bottom-align">
                                        <i class="fa fa-info-circle space-right-5"></i>
                                         <small class="help-block m-b-none"
                                           [i18n]="'regions.form.reverse-cma-check-in.notification.sub-title'"></small>
                                    </span>
                                </div>
                                <div class="form-group">
                                    <div class="requiredInput">
                                        <label class="control-label" [i18n]="'regions.form.reverse-cma-check-in.reasons.title'"></label>
                                        <i class="fa fa-asterisk m-r-xxs requiredInput-icon"></i>
                                    </div>
                                    <app-data-filter-form-autocomplete
                                        [name]="'reverseCheckinReasons'"
                                        [notFoundTextKey]="'common.not-found-item' | translate"
                                        [(model)]="region.features.reverseCheckinReasons"
                                        [multiple]="true"
                                        required>
                                    </app-data-filter-form-autocomplete>
                                    <span class="flex-row bottom-align">
                                        <i class="fa fa-info-circle space-right-5"></i>
                                        <small class="help-block m-b-none" [i18n]="'regions.form.reverse-cma-check-in.reasons.sub-title'"></small>
                                    </span>
                                </div>
                            </div>
                        </app-data-filter-fieldSet>

                        <div class="flex-row center-align form-group">
                            <div class="flex-column grow space-right-30">
                                <label class="control-label" [i18n]="'regions.form.yard-check.trailers-report.label'"></label>
                                <span class="dspl-block inner-space-top-8">
                                    <i class="fa fa-info-circle space-right-5"></i>
                                    <span [i18n]="'regions.form.yard-check.trailers-report.info'"></span>
                                </span>
                            </div>
                            <div class="flex-row no-shrink space-between-5">
                                <app-switcher id="region-trailers-management"
                                              [labelKey]="'regions.form.yard-check.trailers-report.label'"
                                              [(ngModel)]="region.features.yardCheckTrailersManagement"
                                              [name]="'region-trailers-management'">
                                </app-switcher>
                            </div>
                        </div>
                        <div class="flex-row center-align form-group">
                            <div class="flex-column grow space-right-30">
                                <label class="control-label" [i18n]="'regions.form.yard-check.pallets-report.label'"></label>
                                <span class="dspl-block inner-space-top-8">
                                    <i class="fa fa-info-circle space-right-5"></i>
                                    <span [i18n]="'regions.form.yard-check.pallets-report.info'"></span>
                                </span>
                            </div>
                            <div class="flex-row no-shrink space-between-5">
                                <app-switcher id="region-pallets-management"
                                              [labelKey]="'regions.form.yard-check.pallets-report.label'"
                                              [(ngModel)]="region.features.yardCheckPalletsManagement"
                                              [name]="'region-pallets-management'">
                                </app-switcher>
                            </div>
                        </div>

                        <h2 class="text-uppercase" [i18n]="'regions.form.sub-sections.eta'"></h2>

                        <div class="form-group">
                            <app-data-filter-fieldSet [fieldsetTitleKey]="'eta-approximations.title'">
                                <div>
                                    <span class="flex-row bottom-align">
                                        <i class="fa fa-info-circle space-right-5"></i>
                                        <small class="help-block m-b-none" [i18n]="'regions.form.features.location.help'"></small>
                                    </span>
                                    <div class="space-top-10">
                                        <app-eta-approximation-form
                                            [bufferDurations]="region.bufferDurations"></app-eta-approximation-form>
                                    </div>
                                </div>
                            </app-data-filter-fieldSet>
                        </div>
                    </fieldset>
                </form>
            </div>
        </ng-container>
    </app-tab>
    <app-tab *ngIf="!onConfig" [tabId]="'carriers'"
             [selected]="activeTab === 'carriers'"
             [tabTextKey]="'regions.form.section.carriers'"
             (selectedChange)="activeTab = 'carriers'">
        <ng-container>
            <div class="regionDetail-config-container">
                <form #carriersForm="ngForm" (submit)="processForm()" novalidate class="row">
                    <fieldset [disabled]="formProcessingBlocked" class="col-xs-12">

                        <div class="form-group">
                            <app-region-features-editor [features]="region.features" [form]="carriersForm"
                                                        [tmsSyncWindows]="region.tmsSyncWindows" [regionId]="region.id"
                                                        (errorMessageKey)="errorMessageKey = $event"></app-region-features-editor>
                        </div>
                    </fieldset>
                </form>
            </div>
        </ng-container>
    </app-tab>
</app-tabs>

<ng-template #deleteModal let-c="close" let-d="dismiss">
    <span [i18n]="'regions.form.modals.delete.content'"></span>
</ng-template>

<app-floating-footer [doubleButton]="true"
                     [displayError]="generalForm?.invalid || locationsForm?.invalid || carriersForm?.invalid"
                     [errorMessageKey]="errorMessageKey"
                     [leftLabelKey]="'regions.form.buttons.delete'"
                     [leftButtonHidden]="!region || !region.id"
                     [leftButtonDisabled]="deletionBlocked"
                     (leftButtonAction)="openDeleteConfirm(deleteModal)"
                     [rightLabelKey]="'regions.form.buttons.confirm'"
                     (rightButtonAction)="saveRegion()"
                     [rightButtonDisabled]="this.generalForm?.invalid || this.locationsForm?.invalid || this.carriersForm?.invalid
                        || (this.generalForm?.pristine && this.locationsForm?.pristine && this.carriersForm?.pristine)">
</app-floating-footer>
